import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconEventDetailsStyle0 = cosmosIconCss;

const CosmosIconEventDetails$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconEventDetails extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'cbca7de0182e46d6883ac39261d5b6613d681bfd', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f8439812dfcc229f9f0425acbdb5719e5d2814c2', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7c4a6e4e6e828ccb264796b23160ee040bea39be', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 3h-4V2a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v1H9V2a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5v1h-4a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5h-2v-13h3v1A.5.5 0 0 0 8 6h.5a.5.5 0 0 0 .5-.5v-1h4v1a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-1h3v5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5Zm-9.435 8.044a6.99 6.99 0 0 1 2.5-1.603.5.5 0 0 0 .302-.665l-.667-1.56c-.148-.341-.377-.341-.511 0l-.834 2.238-2.42.218c-.376 0-.443.26-.147.491l1.102.922a.498.498 0 0 0 .675-.041ZM9 15.998a5 5 0 1 1 10 .004 5 5 0 0 1-10-.003Zm5.489 3.502A.51.51 0 0 0 15 19v-3a.5.5 0 0 0-.5-.5h-2a.51.51 0 0 0-.511.5v.5a.51.51 0 0 0 .511.5h.989v2a.5.5 0 0 0 .5.5h.5Zm-.25-5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconEventDetailsStyle0; }
}, [1, "cosmos-icon-event-details", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-event-details"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-event-details":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconEventDetails$1);
            }
            break;
    } });
}

const CosmosIconEventDetails = CosmosIconEventDetails$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconEventDetails, defineCustomElement };
